module.exports = __webpack_public_path__ + "static/media/heartRateLine.ccb795c2.svg";